import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const PesajeTrasladoApi = () => {
    const [cargando, setCargando] = useState(false);

    const asignarPesoMateriaPrima = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(
                "traslado_movimientos/pesar-materia-prima",
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const eliminarMateriaPrima = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(
                "traslado_movimientos/eliminar-materia-prima-traslado",
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const darSalidaTraslado = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(
                "traslados/dar-salida-traslado",
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        asignarPesoMateriaPrima,
        eliminarMateriaPrima,
        darSalidaTraslado,
        
        cargando,
    };
};
